import {createElement} from 'react';
import {
  REGEX_COMMUNITY_REPLY,
  REGEX_LINK,
} from '../../../core/entities/community/constants';
import {convertNlToBr} from '../../../shared/services/convertNlToBr';
import {getSeqNumberReplyTo} from './getSeqNumberReplyTo';

export const convertCommentBody = ({
  text,
  openReplyModalFunc,
}: {
  text: string;
  openReplyModalFunc: (seqNumber: number) => void;
}) => {
  // リンクをaタグに変換
  // アンカー(ex: >>1)をbuttonに変換
  const linkRegex = /(https?:\/\/[\w!?/+\-_~=;.,*&@#$%()'[\]]+)/;
  const replyRegex = />>(\d)+?/;
  const regex = REGEX_LINK || REGEX_COMMUNITY_REPLY;

  const convertedText = convertNlToBr(text);
  return convertedText.map((item) => {
    if (typeof item !== 'string') {
      return item;
    }

    return item.split(regex).map((line, i) => {
      if (linkRegex.test(line)) {
        return createElement(
          'a',
          {
            key: `link-${i}`,
            target: '_blank',
            href: line,
            className: 'text-link-1 pc:hover:opacity-80',
          },
          line,
        );
      }

      if (replyRegex.test(line)) {
        // アンカーの直後に改行がない場合、>>1の後の文言ごとbutton担ってしまうので改行をいれる
        const convertedLine = convertWhiteSpaceToBr(line);
        return convertedLine.map((item, i) => {
          if (typeof item !== 'string') {
            return item;
          }

          // 再度アンカーを探してbuttonに変換
          if (replyRegex.test(item)) {
            const seqNumber = getSeqNumberReplyTo(item);
            if (seqNumber === undefined) return item;

            return createElement(
              'button',
              {
                key: `button-${i}`,
                className: 'text-link-1 pc:hover:opacity-80',
                onClick() {
                  openReplyModalFunc(seqNumber);
                },
              },
              item,
            );
          }

          return item;
        });
      }

      return line;
    });
  });
};

const convertWhiteSpaceToBr = (text: string) => {
  const regex = /(\s)/g;
  return text.split(regex).map((line, i) => {
    if (regex.test(line)) {
      return createElement('br', {key: i});
    }

    return line;
  });
};
